"use strict";

import JustValidate from "just-validate";
import autosize from "autosize";

document.addEventListener("DOMContentLoaded", function () {
	const validationFormConfig = {
		errorFieldCssClass: "input__input_invalid",
		errorLabelStyle: {},
		errorLabelCssClass: ["input__error-text"],
	};

	//autosize(document.querySelectorAll("textarea"));

	document.querySelectorAll("textarea").forEach((textarea) => {
		// Функция для обновления высоты
		const updateHeight = () => {
			const currentValue = textarea.value;

			// Временно устанавливаем плейсхолдер как значение, чтобы вычислить высоту
			textarea.value = textarea.placeholder;

			textarea.style.height = "auto";
			textarea.style.height = textarea.scrollHeight + "px";

			textarea.value = currentValue;
		};

		updateHeight();

		textarea.addEventListener("input", () => {
			textarea.style.height = "auto";
			textarea.style.height = textarea.scrollHeight + "px";
		});

		textarea.addEventListener("change", updateHeight);
	});

	function formPersonValidation() {
		const personForm = document.querySelector("#personForm");

		if (personForm) {
			const actionUrl = personForm.getAttribute("action");
			const formValidate = new JustValidate(personForm, validationFormConfig);
			const formFields = personForm.querySelectorAll("input[required]");

			formValidate
				.addField("input[name='first-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='last-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='middle-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='phone']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "customRegexp",
						value: /^(\+7)[\s-]\(([0-9]{3})\)[\s-]([0-9]{3})[\s-]([0-9]{2})[\s-]([0-9]{2})/gi,
						errorMessage: "Некорректный формат",
					},
				])
				.addField("input[name='email']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "email",
						errorMessage: "Некорректный формат",
					},
				])
				.addField("input[name='birthday']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						validator: (value) => {
							return /^\d{2}\.\d{2}\.\d{4}$/.test(value);
						},
						errorMessage: "Дата должна быть в формате ДД.ММ.ГГГГ",
					}
				])
				.addField("input[name='city']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='main-sport']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='sports-category']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='experience']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='padel-experience']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("#grip", [
						{
							validator: (value) => {
								console.log(value)
								return value !== 'grip';
							},
							errorMessage: 'Обязательное поле',
						},
					],
					{
						errorsContainer: document.querySelector('.contacts__select'),
					})
				.onSuccess(() => {
					const formData = new FormData(personForm);
					const plainFormData = Object.fromEntries(formData.entries());
					fetch(actionUrl, formSendConfig(plainFormData)).then((response) => {
						if (response.ok) {
							personForm.reset();
							createSuccessModal();
						} else {
							alert("Ошибка! Попробуйте повторить отправку формы позже.");
						}
					});
				});

			formFields.forEach((field) => {
				field.addEventListener("change", () => {
					formValidate.revalidateField(`input[name='${field.name}']`)
				})
			});
		}
	}

	function formClubValidation() {
		const clubForm = document.querySelector("#clubForm");

		if (clubForm) {
			const actionUrl = clubForm.getAttribute("action");
			const formValidate = new JustValidate(clubForm, validationFormConfig);
			const formFields = clubForm.querySelectorAll("input[required]");

			formValidate
				.addField("input[name='club-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='city']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='contact']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='phone']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "customRegexp",
						value: /^(\+7)[\s-]\(([0-9]{3})\)[\s-]([0-9]{3})[\s-]([0-9]{2})[\s-]([0-9]{2})/gi,
						errorMessage: "Некорректный формат",
					},
				])
				.addField("input[name='email']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "email",
						errorMessage: "Некорректный формат",
					},
				])
				.addField("input[name='website']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='indoor']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='outdoor']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='coaches']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.onSuccess(() => {
					const formData = new FormData(clubForm);
					const plainFormData = Object.fromEntries(formData.entries());
					fetch(actionUrl, formSendConfig(plainFormData)).then((response) => {
						if (response.ok) {
							clubForm.reset();
							createSuccessModal();
						} else {
							alert("Ошибка! Попробуйте повторить отправку формы позже.");
						}
					});
				});

			formFields.forEach((field) => {
				field.addEventListener("change", () => {
					formValidate.revalidateField(`input[name='${field.name}']`)
				})
			})
		}
	}

	function formJudgesValidation() {
		const judgesForm = document.querySelector("#judgesForm");

		if (judgesForm) {
			const actionUrl = judgesForm.getAttribute("action");
			const formValidate = new JustValidate(judgesForm, validationFormConfig);
			const formFields = judgesForm.querySelectorAll("input[required]");

			formValidate
				.addField("input[name='last-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='first-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='middle-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='birthday']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						validator: (value) => {
							return /^\d{2}\.\d{2}\.\d{4}$/.test(value);
						},
						errorMessage: "Дата должна быть в формате ДД.ММ.ГГГГ",
					}
				])
				.addField("input[name='phone']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "customRegexp",
						value: /^(\+7)[\s-]\(([0-9]{3})\)[\s-]([0-9]{3})[\s-]([0-9]{2})[\s-]([0-9]{2})/gi,
						errorMessage: "Некорректный формат",
					},
				])
				.addField("input[name='email']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "email",
						errorMessage: "Некорректный формат",
					},
				])
				.addRequiredGroup(
					'#experience-sport-group',
					'Выберите Ваш опыт судейства'
				)
				.addField("textarea[name='experience']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("textarea[name='category']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("#training-course", [
					{
						validator: (value) => {
							const selectElement = document.querySelector("#training-course");
							const selectedChoice = selectElement.querySelector('option[selected]') ? selectElement.querySelector('option[selected]').value : null;
							return selectedChoice !== null;
						},
						errorMessage: "Выберите один из вариантов",
					},
				])
				.addField("input[name='recruitment']", [
					{
						validator: () => {
							const isChecked = document.querySelectorAll('input[name="recruitment"]:checked').length > 0;
							return isChecked;
						},
						errorMessage: "Выберите один из вариантов",
					},
				])
				.onSuccess(() => {
					const formData = new FormData(judgesForm);
					const plainFormData = Object.fromEntries(formData.entries());
					fetch(actionUrl, formSendConfig(plainFormData)).then((response) => {
						if (response.ok) {
							judgesForm.reset();
							createSuccessModal();
						} else {
							alert("Ошибка! Попробуйте повторить отправку формы позже.");
						}
					});
				});

			// formFields.forEach((field) => {
			// 	field.addEventListener("change", () => {
			// 		formValidate.revalidateField(`input[name='${field.name}']`)
			// 	})
			// });
		}
	}

	function formJuniorsValidation() {
		const juniorsForm = document.querySelector("#juniorsForm");

		if (juniorsForm) {
			const actionUrl = juniorsForm.getAttribute("action");
			const formValidate = new JustValidate(juniorsForm, validationFormConfig);
			const formFields = juniorsForm.querySelectorAll("input[required]");

			formValidate
				.addField("input[name='last-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='first-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='middle-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='birthday']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						validator: (value) => {
							return /^\d{2}\.\d{2}\.\d{4}$/.test(value);
						},
						errorMessage: "Дата должна быть в формате ДД.ММ.ГГГГ",
					}
				])
				.addField("textarea[name='experience']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("textarea[name='category']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='representative']", [
					{
						validator: () => {
							const isChecked = document.querySelectorAll('input[name="representative"]:checked').length > 0;
							return isChecked;
						},
						errorMessage: "Выберите один из вариантов",
					},
				])
				.addField("input[name='representatives-last-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='representatives-first-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='representatives-middle-name']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='representatives-phone']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "customRegexp",
						value: /^(\+7)[\s-]\(([0-9]{3})\)[\s-]([0-9]{3})[\s-]([0-9]{2})[\s-]([0-9]{2})/gi,
						errorMessage: "Некорректный формат",
					},
				])
				.addField("input[name='representatives-email']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "email",
						errorMessage: "Некорректный формат",
					},
				])
				.addField("input[name='city']", [
					{
						rule: "required",
						errorMessage: "Обязательное поле",
					},
					{
						rule: "minLength",
						value: 2,
						errorMessage: "Значение слишком короткое",
					},
					{
						rule: "maxLength",
						value: 50,
						errorMessage: "Значение слишком длинное",
					},
				])
				.addField("input[name='recruitment']", [
					{
						validator: () => {
							const isChecked = document.querySelectorAll('input[name="recruitment"]:checked').length > 0;
							return isChecked;
						},
						errorMessage: "Выберите один из вариантов",
					},
				])
				.onSuccess(() => {
					const formData = new FormData(juniorsForm);
					const plainFormData = Object.fromEntries(formData.entries());
					fetch(actionUrl, formSendConfig(plainFormData)).then((response) => {
						if (response.ok) {
							juniorsForm.reset();
							createSuccessModal();
						} else {
							alert("Ошибка! Попробуйте повторить отправку формы позже.");
						}
					});
				});

			formFields.forEach((field) => {
				field.addEventListener("change", () => {
					formValidate.revalidateField(`input[name='${field.name}']`)
				})
			});
		}
	}

	function formSendConfig(plainFormData) {
		return {
			method: "POST",
			headers: {
				"Content-Type": "application/json;charset=utf-8",
			},
			body: JSON.stringify(plainFormData),
		};
	}

	function createSuccessModal() {
		const successModal = document.querySelector('#form-success')

		if (successModal) {
			const closeModalBtn = successModal.querySelector('.modal-close')

			closeModalBtn.addEventListener('click', () => {
				successModal.classList.remove('active')
			})

			successModal.classList.add('active')
		}
	}

	formPersonValidation();
	formClubValidation();
	formJudgesValidation();
	formJuniorsValidation();

	//Чекбокс Нет опыта сбрасывает все остальные чекбоксы в форме judgesForm
	const judgesFormCheckboxGroup = document.querySelector('#experience-sport-group')

	if (judgesFormCheckboxGroup) {
		const checkboxes = judgesFormCheckboxGroup.querySelectorAll('input[type="checkbox"]')
		const noExperienceCheckbox = judgesFormCheckboxGroup.querySelector('input[name="no-experience"]')

		checkboxes.forEach(checkbox => {
			checkbox.addEventListener('change', (el) => {
				if (el.target.name === 'no-experience') {
					checkboxes.forEach(item => {
						item.checked = false
						el.target.checked = true
					})
				} else {
					noExperienceCheckbox.checked = false
					el.target.checked = true
				}
			})
		})
	}
})
